import styled from "styled-components";

export const AppContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-direction: column;
`;
